var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disclaimer-addon"},[_c('el-input',{attrs:{"type":"textarea","rows":6},model:{value:(_vm.disclaimer),callback:function ($$v) {_vm.disclaimer=$$v},expression:"disclaimer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }